export default __webpack_public_path__ + "005038f1428d6307f4141f8d4cccdc07.jpg";